import { AccessibilityEditor } from "../AccessibilityEditor.js";
import type { StaffAccessibilityPreferences } from "../staffAccessibility.js";
import { SettingsTabs } from "./SettingsTabs.js";

export function StaffAccessibility({
  preferences,
  onSave,
  onReset,
  onApplied,
}: {
  preferences: StaffAccessibilityPreferences;
  onSave: (preferences: StaffAccessibilityPreferences) => Promise<StaffAccessibilityPreferences>;
  onReset: () => Promise<StaffAccessibilityPreferences>;
  onApplied: (preferences: StaffAccessibilityPreferences) => void;
}) {
  return (
    <section aria-label="Accessibility settings">
      <h1>Settings</h1>
      <SettingsTabs />
      <h2>Accessibility</h2>
      <p className="lede">
        Adjust how the staff Hub looks for you. These settings only change how information is
        displayed; they do not change bookings, permissions or other staff members' views.
      </p>
      <p className="small muted">
        Your choices are remembered for this staff account on this browser.
      </p>

      <AccessibilityEditor
        preferences={preferences}
        onSave={onSave}
        onReset={onReset}
        onApplied={onApplied}
      />
    </section>
  );
}
